import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Validation
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer

import ProductForm from '../../../components/product/ProductForm.vue'
let service = new services();
let validator = new validation();
export default {
    name: 'Sellpoint',
    data () {
        return {
            loading:false,
            page_set:false,
            user: {},
            sellpoint: {},
            categories:{},
            voucher:{},
            voucher_name:"",
            voucher_amount:0,
            orders:{},
            notifications:{},
            messages:{},
            details:{},
            cities:{},
            states:{},
            contact_form: {},
            category:{},
            service:{},
            delivery_option:{},
            discount_coupon:{},
            products: {},
            product:{},
            market:{},
            product_item: {},
            can_edit: false,
            edit_mode:false,
            disable_btn: false,
            setPanel: false,
            listView:true,
            marketView:false,
            addProductPanel:false,
            spProductsPanel:false,
            spMarketPanel:false,
            spProfilePanel:false,
            spContactPanel:false,
            spDeliveryPanel:false,
            spMessagesPanel:false,
            spOrdersPanel:false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            spSettingsPanel:false,
            setDiscount:false,
            viewDiscounts:true,
            createSellpointPanel: false,
            viewAllProductsBanner:false,
            showSidebarMobile:false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            bg_main:'',
            other_delivery_option:false,
            edit_other_delivery_option:false,
            set_bank_details: false,
            edit_city:false,
            ipaddress: "",
            notifications_unread: 0,

            ///
            default_banner_image: service.default_banner_image,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'product-form': ProductForm
     },
    methods: {
        setMenuComponent(){},

        setComponent(attr1,attr2){
            this.setPanel = true;
            if(attr1 == 'create-sellpoint'){
                this.createSellpointPanel= true;
                this.addProductPanel= false;
            }
            if(attr1 == 'sellpoint-panel'){
                this.addProductPanel= false;
            }
            if(attr1 == 'spProductsPanel'){
                this.spMarketPanel = false;
                this.spProductsPanel= true;
                this.spProfilePanel=false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                //check for market
                if(attr2 == 'market'){
                    this.spMarketPanel = true;
                }
            }
            if(attr1 == 'spProfilePanel'){
                this.spProductsPanel= false;
                this.spProfilePanel= true;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
            }
            if(attr1 == 'spContactPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= true;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
            }
            if(attr1 == 'spDeliveryPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spDeliveryPanel = true;
            }
            if(attr1 == 'spMessagesPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spOrdersPanel = false;
                this.spMessagesPanel = true;
            }
            if(attr1 == 'spOrdersPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = true;
            }
            if(attr1 == 'spSettingsPanel'){
                this.spProductsPanel=false;
                this.spProfilePanel= false;
                this.spContactPanel= false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = true;
                
            }
            if(attr1 == 'add-product'){
                this.addProductPanel= true;
                this.createSellpointPanel= false;
            }
            if(attr1 == 'edit-category'){
                this.category.edit = false;
                this.category = attr2;
                this.category.edit = true;
            }
            if(attr1 == 'reset-edit-category'){
                this.category.edit = false;
                this.category = {}
            }
            
            if(attr1 == 'view-all-products'){
                this.viewAllProductsBanner = false;
                this.getSellpointProducts();
            }
            if(attr1 == 'list-view'){
                this.marketView = false;
                this.listView = true;
            }
            if(attr1 == 'market-view'){
                this.marketView = true;
                this.listView = false;
            }
            if(attr1 == 'add-delivery-information'){
                this.addDeliveryInformation = true;
            }
            if(attr1 == 'set-discount'){
                this.setDiscount = true;
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
            }
            if(attr1 == 'view-discounts'){
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.viewDiscounts = true;
            }
        },

        setComponentActions(attr1,attr2){
            if(attr1 == 'edit-service'){
                this.service.edit_set = false;
                this.service = attr2;
                this.service.edit_set = true;
            }
            if(attr1 == 'edit-delivery-option'){
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state,'edit'); //option edit
            }
            if(attr1 == 'edit-tagline'){
                this.details = {};
                this.details.tagline_edit = true;
            }
            if(attr1 == 'edit-profile'){
                this.details = {};
                this.details.profile_edit = true;
            }
            if(attr1 == 'edit-contact-info'){
                this.details = {};
                this.details.contact_info_edit = true;
            }
            if(attr1 == 'edit-delivery-information'){
                this.details = {};
                this.details.delivery_edit = true;
            }
            if(attr1 == 'edit-bank-details'){
                this.details = {};
                this.details.bank_details_edit = true;
                this.set_bank_details = true;
            }
            if(attr1 == 'reset-delivery-information'){
                this.addDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = false;
            }
            if(attr1 == 'edit-discount-coupon'){
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }
            if(attr1 == 'reset-discount-coupon'){
                this.viewDiscounts = true;
                this.discount_coupon.edit = false;
                this.discount_coupon = {};
                this.setDiscount = false;
            }
            if(attr1 == 'reset-edit'){
                this.details = {};
            }
        },
        
        
        prep: function() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");
            //return Home;
            return parts[0];
        },

        toggleSidebar(){
            if(this.showSidebarMobile == true){
                this.showSidebarMobile = false;
            }else{
                this.showSidebarMobile = true;
            }
        },
        preset() {
            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            //set sellpoint and seller options
                           this.setSellpoint();
                        }, this);
                    }else {
                      //  console.log(response)
                     this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        console.log(err)
                        this.$router.push('login');
                    }
                })
            }else {
               //console.log("error 2")
               this.$router.push('login');
            }
        },

        is_editing(){ //preseting if seller
            if(this.user.user_id != ""){
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                }
                service.can_edit(this, payload).then(response => {
                    if(response.body.status == 200) {
                        this.edit_mode =  true;
                        this.can_edit = true;
                    }else {
                        this.edit_mode =  false;
                    }
                }).catch((err) => {
                    if(err) {
                        //log error
                    }
                })
            }
        },

        switchMode(){
            if(this.edit_mode == false){
                this.is_editing(); //revalidate seller
            }else{
                this.edit_mode = false;
                this.can_edit = true;
            }
        },

        //getIPAddress
        getIPAddress(){
            // service.getIPAddress(this).then(response => {
            //     this.ipaddress = response.data
            // }).catch((err) => {})
        },
        
        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state,option){
            if(option == "edit"){this.edit_city = true;}
            else{this.edit_city = false}
            service.getCities(this,state).then(response => {
                if(response.body.status == 200) {
                    this.cities = response.body.data;
                }
            }).catch((err) => {})
        },

        setOtherOptions(v,o){
            if(v != undefined){
                if(v == "other"){
                    this.other_delivery_option = true;
                    if(o == "edit"){this.edit_other_delivery_option = true;}//for edit
                }
                if(v == "all"){
                    this.delivery_option.business_delivery_other_option = "nill";
                    if(o == "edit"){this.edit_other_delivery_option = false;}//for edit
                    this.other_delivery_option = false;
                }
            }
            
        },

        viewCategoriesProducts(){},

        setSellpoint(){
            this.loading = true;
            let sp = "";
            if(this.$route.params.id != undefined){
                sp = this.$route.params.id;
             }
            else{
                sp = this.prep();
            }
            service.getBusinessByUserName(this, sp).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data;
                    localStorage.setItem("sp_#_sellpoint",this.sellpoint.business_username); //use storage for now if buggy set in as url get param
                    this.is_editing();
                    this.getCategories(this.sellpoint.business_category_id);
                    this.getSellpointProducts(); // if basic sellpoint
                    if(this.sellpoint.business_market_category_id != 1){
                        this.getSellpointMarket();
                        this.getSellpointMarketProducts();
                       // localStorage.setItem("sp_#_sellpoint",this.sellpoint.business_username);
                    }
                    this.spProductsPanel = true; //use loaders subsequently to make sure other above is loaded
                    this.loading = false;

                    //get other info
                    // this.getSellpointNotifications();
                    // this.getSellpointMessages();
                    // this.getSellpointOrders();
                    //promises hub
                    let promises = [];
                    for (let i = 0; i < 5; ++i) {
                        if(i == 1){
                            //check for available coupons
                            promises.push(
                                this.getSellpointNotifications()
                            )
                        }
                        
                        if(i == 2){
                            //prep delivery options
                            promises.push(
                                this.getSellpointMessages()
                            )
                        }

                        if(i == 3){
                            // check pay on delivery
                            promises.push(
                                this.getSellpointOrders()
                            )
                        }
                    }
                
                    //process all promises
                    Promise.all(promises)
                    .then(() => {})
                    .catch((e) => {});
                //..promises hub
                    
                }else{
                    location.reload(true); //manage with this for now
                   // console.log(response)
                   //this.$router.push('login');
                   
                }
            }).catch((err) => {
                //log it
                location.replace("/");
              //console.log(err);
              this.loading = true;
            })
        },

        getSellpointNotifications(){
            service.getBusinessNotifications(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.notifications = response.body.data;
                    this.notifications_unread = response.body.data_1;
                }
            }).catch((err) => {})
        },

        getSellpointMessages(){
            service.getBusinessMessages(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.messages = response.body.data;
                }
            }).catch((err) => {})
        },

        getSellpointOrders(){
            service.getBusinessOrders(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.orders = response.body.data;
                }
            }).catch((err) => {})
        },

        getSellpointProducts(){
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSellpointMarketProducts(){
            service.getMarketProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSellpointMarket(){
            service.getBusinessMarket(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data;
                }
            }).catch((err) => {
                this.getIPAddress();
                this.market = {};
               // set error payload
               let err_payload = {
                    err_int_id: this.user.user_id || 0,
                    err_mod_id: 5, //sellpoint page
                    err_route: this.$route.path,
                    err_func: "getSellpointMarket",
                    err_api_cl: "GET::"+err.url,
                    err_message: err.bodyText,
                    err_ln_rang: '363-377',
                    err_poss_cos: "returned could be 404 || 400",
                    err_ip_address: this.ipaddress
                }
                //service.sendErrorLog(this, err_payload).then().catch(() => {})
                //send error to log
            })
                
        },


        getCategories(category){
            service.getBusinessSubCategories(this, category).then(response => {
                if(response.body.status == 200) {
                    this.categories = response.body.data;
                }
            }).catch((err) => {})
                
        },

        addCategory(){
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                business_id: this.sellpoint.business_id
            }
            service.addCategory(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    toastr.success("Sellpoint Category Added Successfull", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch((err) => {
                //log it
            })
        },

        editCategory(){
            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function(data) {
                if(data.body.status == 200) {
                    toastr.success("Sellpoint Category edited", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch((err) => {
                //log it
                this.category = {};
            })
        },

        getCategoryProducts(category){
            service.getCategoryProducts(this, category).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.viewAllProductsBanner = true;
                    this.showSidebarMobile = false;
                }
            }).catch((err) => {})
        },

    //     createSellpoint(){
    //         this.disable_btn = true;
    //         this.business.agree = true;
    //         var credentials = {
    //             business_name: this.business.business_name,
    //             business_category: this.business.business_category || 1,
    //             business_owner: this.user.user_id,
    //         }
    //         let navi = this.$router;
    //        if(credentials.business_name != undefined && credentials.business_category != undefined) {
    //             if(this.business.agree) {
    //                 service.addBusiness(this, credentials).then(function(data) {
    //                     if(data.body.status == 201) {
    //                         toastr.success("Sellpoint Creation Successfull", 'Success!');
    //                         //log user in
    //                         this.business = data.body.data;
    //                         this.setComponent('add-product','');
    //                     }
    //                 }).catch((err) => {
    //                     if(err) {
    //                         toastr.warning("Something went wrong", 'Warning!'); 
    //                         this.disable_btn = false;
    //                         console.log(err)
    //                     }
    //                 })
    //             }else {
    //                 toastr.error('Please agree to Terms', 'Warning!');
    //                 this.disable_btn = false;
    //             }
    //         }else {
    //             toastr.error('Kindly fill all fields', 'Warning!');
    //             this.disable_btn = false;
    //         }
    // },

         //uploads
    onFileChange(e,type) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {
            let formData = new FormData();
            formData.append('photo', files[0]);
            formData.append('data_id', this.sellpoint.business_id); 
            formData.append('data_type', type); 
            service.uploadBusinessDataPhoto(this, formData).then(data => {
                if(data.body.status == 200){
                    if(type == "business_banner_image"){
                        this.sellpoint.business_banner_image = data.body.data;
                    }
                    if(type == "business_brand_image"){
                        this.sellpoint.business_brand_image = data.body.data;
                    }
                }
                }).catch((err) => {
                    if(err) {
                       // log it
                    }
            })
        }   
            
    },

    addService(){
        var payload = {
            business_service: this.service.service_name || "Service Details",
            business_id: this.sellpoint.business_id
        }
        service.addService(this, payload).then(function(data) {
            if(data.body.status == 201) {
                toastr.success("Sellpoint Service Added Successfully", 'Success!');
                this.sellpoint.business_services = data.body.data;
                this.service = {};
            }
        }).catch((err) => {
            //log it
            this.service = {};
        })
    },

    editService(){
        this.service.business_id = this.sellpoint.business_id;
        service.editService(this, this.service).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Sellpoint Service edited",'Success!');
                this.sellpoint.business_services = data.body.data;
                this.service.edit_set = false;
                this.service = {};
            }
        }).catch((err) => {
            //log it
            this.service = {};
        })
    },

    

    addDeliveryOption(){
        var payload = {
            business_delivery_state: this.delivery_option.state,
            business_delivery_city: this.delivery_option.city || 0,
            business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
            business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
            business_id: this.sellpoint.business_id
        }
        if(payload.business_delivery_option_price == 0){
            toastr.warning("Delivery Charge not Added", 'Warning!');
        }else{
            if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                service.addDeliveryOption(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                        this.sellpoint.business_delivery_options = data.body.data;
                        this.delivery_option = {};
                        this.addDeliveryInformation = false;
                    }
                }).catch((err) => {
                    //log it
                    this.delivery_option = {};
                })
            }else{
                toastr.warning("Select a delivery option", 'Warning!');
            }
        }
        
    },

    editDeliveryOption(){
        var payload = {
            business_id: this.sellpoint.business_id,
            business_delivery_state: this.delivery_option.business_delivery_state,
            business_delivery_city: this.delivery_option.city || 0,
            business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
            business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
            business_delivery_option_id: this.delivery_option.business_delivery_option_id
        }
        //this.delivery_option.business_id = this.sellpoint.business_id;
        if(payload.business_delivery_option_price == 0){
            toastr.warning("Delivery Charge not Added", 'Warning!');
        }else{
            if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                service.editDeliveryOption(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    toastr.success("Sellpoint Delivery Details edited",'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.editDeliveryInformation = false;
                    //this.delivery_option = {};
                }
                }).catch((err) => {
                    //log it
                    //this.delivery_option = {};
                    this.delivery_option.edit_set = false;
                        this.editDeliveryInformation = false;
                })
            }else{
                toastr.warning("Select a delivery option", 'Warning!');
            }
        }
    },

    deleteDeliveryOption(id){
        var payload = {
            business_id: this.sellpoint.business_id
        }
        service.deleteDeliveryOption(this, id, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Sellpoint Delivery Details deleted",'Success!');
                this.sellpoint.business_delivery_options = data.body.data;
                this.delivery_option.edit_set = false;
                this.delivery_option = {};
            }
        }).catch((err) => {
            //log it
            this.delivery_option = {};
        })
    },

    //delivery option

    editBusinessDetails(attr){
        if(attr == "tagline"){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_tagline: this.sellpoint.business_tagline
            }
        }
        if(attr == "profile"){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_profile: this.sellpoint.business_profile
            }
        }
        if(attr == "contact_info"){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_emails: this.sellpoint.business_emails,
                business_address: this.sellpoint.business_address,
                business_phones: this.sellpoint.business_phones
            }
        }
        if(attr == "delivery"){
            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_information: this.sellpoint.business_delivery_information
            }
        }
        service.editBusinessDetails(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Sellpoint edited", 'Success!');
            }
             this.details = {};
        }).catch((err) => {
            //log it
            this.details = {};
        })
    },

    sendBusinessContactForm(){
        var payload = {
            business_id: this.sellpoint.business_id,
            contact_form_name: this.contact_form.name || "nill",
            contact_form_email: this.contact_form.email || "nill",
            contact_form_message: this.contact_form.message || "nill"
        }
        service.sendBusinessContactForm(this, payload).then(function(data) {
            if(data.body.status == 201) {
                toastr.success("Message Sent", 'Ok!');
            }
             this.contact_form = {};
        }).catch((err) => {
            //log it
            this.contact_form = {};
        })
    },

    //set coupons and discount
    setDiscountsAndCoupons(){
        //validate entry
        let entry_arr = [
            ["Discount or Coupon",this.discount_coupon.is_discount_coupon,"str"],
            ["Coupon Percentage",this.discount_coupon.discount_percentage,"num"],
            ["Discount Category",this.discount_coupon.discount_category,"num"],
            ["Start Date",this.discount_coupon.discount_start_date,"date"],
            ["End Date",this.discount_coupon.discount_end_date,"date"]
        ];
        let validated_arr = validator.validate_array(entry_arr,"Please fill in ");
        if(validated_arr.length == 0){
            var payload = {
                business_id: this.sellpoint.business_id,
                product_item_id: 0,
                is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C', //or coupon
                coupon_business_category:this.discount_coupon.discount_category,
                coupon_percentage: this.discount_coupon.discount_percentage,
                coupon_start_date: this.discount_coupon.discount_start_date,
                coupon_end_date: this.discount_coupon.discount_end_date,
            }
            service.setDiscountsAndCoupons(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    toastr.success("New Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon','');
                }
            }).catch((err) => {
                //log it
            })
        }else{
            validated_arr.forEach(function(error) {
                toastr.error(error); 
            }, this);
        }
        
    },

    // edit coupons and discount
    editDiscountsAndCoupons(){
        this.discount_coupon.business_id = this.sellpoint.business_id;
        service.editDiscountsAndCoupons(this, this.discount_coupon).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Discount Set", 'Update!');
                this.sellpoint.business_discounts_coupons = data.body.data;
                this.setComponentActions('reset-discount-coupon','');
            }
        }).catch((err) => {
            //log it
        })
    },

    
    // edit coupons and discount
    deactivateDiscountsAndCoupons(payload){
        payload.business_id = this.sellpoint.business_id;
        service.deactivateDiscountsAndCoupons(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Discount Set", 'Update!');
                this.sellpoint.business_discounts_coupons = data.body.data;
                this.setComponentActions('reset-discount-coupon','');
            }
        }).catch((err) => {
            //log it
        })
    },

    //set bank details
    setBankDetails(){
        var payload ={
            business_bank_name: this.sellpoint.business_bank_details.bank_name,
            business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
            business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
            business_id:this.sellpoint.business_id
        }
       
        service.setBusinessBankDetails(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Bank Details Set", 'Update!');
            }
            this.set_bank_details = false;
        }).catch((err) => {
            //log it
        })
    },

    //processing fee switch
    switchProcessingFee(to){
        var payload ={
            business_process_fee_pay: to,
            business_id:this.sellpoint.business_id
        }
       
        service.switchProcessingFeePay(this, payload).then(function(data) {
            if(data.body.status == 200) {
                toastr.success("Processing Fee Set", 'Reset!');
                this.sellpoint.business_processing_fee_pay_status = to;
            }
        }).catch((err) => {
            //log it
        })
    },

    //read general notifications for all messages, orders and notifications
    readNotifications(){
        this.notifications_unread = 0; //read all
        var payload ={
            notification_type: "business",
            notification_module: "notifications",
            notification_business:this.sellpoint.business_username
        }
        service.readNotifications(this,payload).then(function(data) {}).catch((err) => {})
    },

    /////********vstore */
    createVoucher(){
        // this.disable_btn = true;
        // //this.business.agree = true;
        // var credentials = {
        //     business_id: this.sellpoint.business_id,
        //     business_voucher_name: this.voucher_name,
        //     business_voucher_amount: this.voucher_amount || 1000,
        //     business_voucher_duration: this.voucher.duration || 10,
        //     business_voucher_paid_by: this.voucher.paid_by || 0
        // }
        
        // let navi = this.$router;
        // if(credentials.business_voucher_name != undefined) {
        //     service.createBusinessVoucher(this, credentials).then(function(data) {
        //         if(data.body.status == 201) {
        //             toastr.success("Voucher Added Successfully", 'Success!');
        //            // this.product = data.body.data;
                    
                    //generate image
                    // var cnvs = document.getElementById('cnvs'),
                    // ctx = cnvs.getContext('2d'),
                    // mirror = document.getElementById('mirror');
                
                    // cnvs.width = mirror.width = window.innerWidth;
                    // cnvs.height = mirror.height = window.innerHeight;

                    // html2canvas(document.querySelector("#vouchercapture")).then(canvas => {
                    //     console.log(canvas)
                    //     document.body.appendChild(canvas)
                    //      // Convert and download as image 
                    //   // Canvas2Image.saveAsPNG(canvas); 
                    //     $("#doty").append("canvas");
                    //     $("#doty").append(canvas);
                    //     let formData = new FormData();
                    //     let imagedata = canvas.toDataURL('image/png');
		            //     let imgdata = imagedata.replace(/^data:image\/(png|jpg);base64,/, "");
                    //     formData.append('photo', imgdata);
                    //     formData.append('data_id', this.sellpoint.business_id); 
                    //     formData.append('data_type', "business_voucher"); 
                    //     service.uploadBusinessDataPhoto(this, formData).then(data => {
                    //         if(data.body.status == 200){
                    //         //close modal and reload
                    //         }
                    //         }).catch((err) => {
                    //                 if(err) {console.log(err)
                    //                 // log it
                    //                 }
                    //             toastr.warning("Something went wrong.", 'Warning!');
                    //     })
                    // }); 


                    
        //         }
        //     }).catch((err) => {
        //         if(err) {
        //             toastr.warning("Something went wrong", 'Warning!'); 
        //            // console.log(err)
        //             this.disable_btn = false;
        //         }
        //     })
        // }else {
        //     toastr.error('Kindly fill all fields', 'Warning!');
        //     this.disable_btn = false;
        // }
    },

    ///*****/vstore */

},
mounted: function(){
   this.loading = true;
    if((localStorage.getItem("sp_token")) != undefined){
      this.preset();
    }else{
        this.setSellpoint()
    }
},
created: function(){
    this.loading = true;
    // //this.setSellpoint();
    // if((localStorage.getItem("sp_token")) != undefined){
    //    // this.preset();
    // }else{
    //     this.setSellpoint();
    // }
    this.getStates();
    this.getIPAddress();
    
}
}


// WEBPACK FOOTER //
// ./src/pages/Sellpoint/Sellpoint/script.js